module.exports = __webpack_public_path__ + "img/a10-image-file.32d79d0b.svg";